export default __webpack_public_path__ + "static/media/UdunkuluVector.fe825ced.svg";